import type { ReactNode } from 'react';
import { pillRecipe, pillTone } from './Pill.css';

export type PillTone = 'neutral' | 'active' | 'inactive' | 'urgent' | 'warning' | 'info' | 'const';
export type PillSize = 'sm' | 'md' | 'lg';
/** 선행 마커 글리프. 'hex'면 children 앞에 ⬢(시나리오 마커)를 형제로 렌더. 기본 'none'. */
export type PillMarker = 'none' | 'hex';

export interface PillProps {
  tone?: PillTone;
  size?: PillSize;
  /** children 앞 선행 마커. 'hex' = ⬢ (색은 currentColor로 톤 색 상속, aria-hidden). */
  marker?: PillMarker;
  children?: ReactNode;
  className?: string;
}

export function Pill({
  tone = 'neutral',
  size = 'sm',
  marker = 'none',
  children,
  className,
}: PillProps) {
  const cls = `${pillRecipe({ size })} ${pillTone[tone]}${className ? ` ${className}` : ''}`;
  return (
    <span className={cls}>
      {marker === 'hex' && <span aria-hidden="true">⬢</span>}
      {children}
    </span>
  );
}
